<template>
    <v-modal :width="420" :visible="visible" @cancel="cancel">
        <div class="fail-modal color-dark-1 txt-c">
            <i class="iconfont icon-shibai"></i>
            <div class="font-size-24 margin-top-30">{{ title }}</div>
            <div class="font-size-14 margin-top-10">{{ msg }}</div>
        </div>
        <div slot="footer" class="txt-c"></div>
    </v-modal>
</template>

<script>
import mixins from '@/configs/mixins';

const initData = () => ({
    visible: false,
    title: '修改失败',
    msgType: '',
    msg: '修改失败，或许长得真帅的人才能修改',
    changePassMsg: ''
});

export default {
    name: 'FailModal',
    mixins: [mixins],
    destroyed() {
    },
    data() {
        return initData();
    },
    watch: {
    },
    methods: {
        cancel() {
            const self = this;
            setTimeout(() => {
                self.updateState(initData());
            }, 1000);
        },
    }
};
</script>

<style scoped lang="less">
.fail-modal {
    padding: 83px 0 47px 0;
    .iconfont {
        font-size: 40px;
        line-height: 1;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/FailModal/FailModal.vue